import * as Yup from "yup";

const NumbersRegExp = /^\d{5,11}$/;

export const validationDocumentDelivery = Yup.object().shape({
  documentNumber: Yup.string()
    .matches(NumbersRegExp, "Por favor escriba un número de documento valido, solo números.")
    .required("Campo obligatorio."),
});
